const defaultNewsCards = [
  {
    title: 'Fait marquant #1',
    content: 'Publiez votre contenu depuis l’interface administrateur pour alimenter le site en temps réel.'
  },
  {
    title: 'Fait marquant #2',
    content: 'Partagez les coulisses, les réactions à chaud et les infos mercato des Lions du Haut-Nkam.'
  },
  {
    title: 'Fait marquant #3',
    content: 'Annoncez les prochaines rencontres, focus joueurs ou initiatives communautaires du club.'
  }
];

export const sanitizeNewsCards = (value) => {
  if (!Array.isArray(value) || value.length === 0) {
    return defaultNewsCards.map((item) => ({ ...item }));
  }
  return defaultNewsCards.map((fallback, index) => {
    const next = value[index];
    if (!next || typeof next !== 'object') {
      return { ...fallback };
    }
    const title = typeof next.title === 'string' && next.title.trim().length ? next.title : fallback.title;
    const content =
      typeof next.content === 'string' && next.content.trim().length ? next.content : fallback.content;
    return { title, content };
  });
};

export default defaultNewsCards;
